import { useState, useEffect } from 'react';
import obelisk from '../clients/obelisk';
/**
 * Fetches a single sign-on (SSO) token for the given customer ID.
 * @param {string} customerId
 * @returns {{ setCid: function, token: string|null }} An object containing the function to set the customer ID and the fetched SSO token.
 */
const useSsoHook = (customerId) => {
  const [cid, setCid] = useState(customerId);
  const [token, setToken] = useState(null);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    if (!cid) return;
    const getSsoToken = async () => {
      const { data: token } = await obelisk()
        .setHeader('content-type', 'text/plain')
        .get('Authorize/GetSSOToken', { AssociateId: cid });
      setToken(token);
      setReady(true);
    };
    getSsoToken();
  }, [cid]);

  return { setCid, token, ready };
};

export default useSsoHook;
